import { css } from '@emotion/react';

type FlexProps = {
  type: 'row' | 'column';
  alignItems?: string | null;
  justifyContent?: string | null;
  gap?: number | null;
  cursor?: string | null;
  wrap?: 'wrap' | 'nowrap';
  padding?: string | null;
  margin?: string | null;
  minHeight?: string | null;
  width?: string;
  children: React.ReactNode;
};

const FlexLayout = ({
  type = 'column',
  alignItems = null,
  justifyContent = null,
  gap = null,
  cursor = 'default',
  wrap = 'nowrap',
  padding = '0',
  margin = '0',
  minHeight = null,
  width = '100%',
  children,
}: FlexProps) => {
  return (
    <div css={root({ type, cursor, alignItems, justifyContent, gap, wrap, padding, margin, minHeight, width })}>
      {children}
    </div>
  );
};

const root = ({ type, cursor, alignItems, justifyContent, gap, wrap, padding, margin, minHeight, width }: any) => css`
  display: flex;
  flex-direction: ${type};
  ${justifyContent ? `justify-content: ${justifyContent};` : null}
  ${alignItems ? `align-items: ${alignItems};` : null}
  ${gap ? `gap: ${gap}rem;` : null}
  flex-wrap: ${wrap};
  width: ${width};
  cursor: ${cursor};
  padding: ${padding};
  margin: ${margin};
  ${minHeight && `min-height: ${minHeight};`}
`;

export default FlexLayout;
